import { render } from "./quoteTwo.vue?vue&type=template&id=4090166c"
import script from "./quoteTwo.vue?vue&type=script&lang=js"
export * from "./quoteTwo.vue?vue&type=script&lang=js"

import "./quoteTwo.vue?vue&type=style&index=0&id=4090166c&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__